import { ValidateGlobalPay } from '../index';

/** Action creators */
export const validateMerchantDetails = async (details) => {
  return ValidateGlobalPay(details);
};
